import AppForm from '../app-components/Form/AppForm';

Vue.component('app-user-office-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                admin_user_id:  '' ,
                app_offices_id:  '' ,
                name:  '' ,
                
            }
        }
    }

});